import type {
  CustomerGroupStatRowDTO,
  SalesByChannelRowDTO,
  SalesByCustomerGroupRowDTO,
  SalesBySocialSourceRowDTO,
  SalesGranularity,
  SalesTimeseriesBucketDTO,
} from "@/modules/reports/domain/contracts";
import { config } from "@/shared/lib/config";
import { fetcher } from "@/shared/lib/fetcher";

export type {
  CustomerGroupStatRowDTO,
  SalesByChannelRowDTO,
  SalesByCustomerGroupRowDTO,
  SalesBySocialSourceRowDTO,
  SalesGranularity,
  SalesTimeseriesBucketDTO,
};

export const reportsApi = {
  async salesTimeseries(query: {
    from: string;
    to: string;
    granularity: SalesGranularity;
  }): Promise<SalesTimeseriesBucketDTO[]> {
    const url = new URL(`${config.apiUrl}/reports/sales-timeseries`);
    url.searchParams.set("from", query.from);
    url.searchParams.set("to", query.to);
    url.searchParams.set("granularity", query.granularity);
    return fetcher.get<SalesTimeseriesBucketDTO[]>(url.toString());
  },

  async salesByChannel(query: {
    from: string;
    to: string;
  }): Promise<SalesByChannelRowDTO[]> {
    const url = new URL(`${config.apiUrl}/reports/sales-by-channel`);
    url.searchParams.set("from", query.from);
    url.searchParams.set("to", query.to);
    return fetcher.get<SalesByChannelRowDTO[]>(url.toString());
  },

  async salesBySocialSource(query: {
    from: string;
    to: string;
  }): Promise<SalesBySocialSourceRowDTO[]> {
    const url = new URL(`${config.apiUrl}/reports/sales-by-social-source`);
    url.searchParams.set("from", query.from);
    url.searchParams.set("to", query.to);
    return fetcher.get<SalesBySocialSourceRowDTO[]>(url.toString());
  },

  async salesByCustomerGroup(query: {
    from: string;
    to: string;
  }): Promise<SalesByCustomerGroupRowDTO[]> {
    const url = new URL(`${config.apiUrl}/reports/sales-by-customer-group`);
    url.searchParams.set("from", query.from);
    url.searchParams.set("to", query.to);
    return fetcher.get<SalesByCustomerGroupRowDTO[]>(url.toString());
  },

  async customerGroupStats(): Promise<CustomerGroupStatRowDTO[]> {
    return fetcher.get<CustomerGroupStatRowDTO[]>(
      `${config.apiUrl}/reports/customer-group-stats`,
    );
  },
};
